import { render, staticRenderFns } from "./JobTagsInput.vue?vue&type=template&id=67984bd6&"
import script from "./JobTagsInput.vue?vue&type=script&lang=js&"
export * from "./JobTagsInput.vue?vue&type=script&lang=js&"
import style0 from "./JobTagsInput.vue?vue&type=style&index=0&id=67984bd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports